import {
  Button,
  Dialog,
  DialogContent,
  ListItem,
  ListItemText,
  makeStyles,
} from "@material-ui/core";
import { Field, FieldArray } from "formik";
import { RemoveCircleOutlined } from "@material-ui/icons";

import React from "react";
import FMUSelect from "./shared/FormIkMUFormComponent/FMUSelect";
import Select from "react-select";
import { getRelationship } from "./shared/helpers/helper";
import AddIcon from "@material-ui/icons/AddCircle";
import { tokens } from "../theme/tokens";

const relationships = getRelationship();

const useStyle = makeStyles(() => ({
  input: {
    // width: "95%",
    border: `1px solid ${tokens.color.border.default}`,
    borderRadius: "10px",
    height: "40px",
    paddingLeft: "3px",
    "& .MuiInputBase-input": {
      textIndent: "10px",
    },
    backgroundColor: tokens.color.surface.sunken,
  },
  dialogContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    rowGap: "20px",
    width: "70%",
    margin: "auto",
    paddingBottom: "20px",
    textAlign: "center",
  },
  dialogHeading: {
    color: "#585858",
    fontSize: "1em",
    fontFamily: tokens.type.family,
    fontWeight: 500,
    textAlign: "center",
  },
  dialogItem: {
    display: "flex",
    columnGap: "25px",
    alignItems: "center",
  },
  linkItemText: {
    fontSize: "1em",
    color: "#000",
  },
  dialogBtn: {
    marginTop: "0",
    backgroundColor: "white",
    color: tokens.color.brand.primaryAction,
    boxShadow: "0 3px 3px rgba(0,0,0,0.1607843137254902 )",
    width: "220px",
    marginLeft: "120px",
    textTransform: "capitalize",
  },
}));

function RelationDialog({
  rDialog,
  setRDialog,
  index,
  data,
  setFieldValue,
  relationshipOptions,
  arrayName,
}) {
  const classes = useStyle();
  return (
    <Dialog
      open={rDialog}
      maxWidth={"lg"}
      classes={{ paper: classes.socialMediaPaper }}
      onClose={(e) => {
        setRDialog(false);
      }}
    >
      <DialogContent>
        <div
          style={{ width: "800px", paddingTop: "4vh", paddingBottom: "4vh" }}
        >
          <div className={classes.dialogContainer} style={{ width: "100%" }}>
            <h2 className={classes.dialogHeading}>
              Add or update Relationship to subject
            </h2>
            <FieldArray
              //   case_detail.case_details.Subjects_information
              name={`${arrayName}[${index}].relationship`}
            >
              {({ push, remove }) => (
                <>
                  {data[index]?.relationship?.map((val, key) => {
                    return (
                      <div
                        className={classes.dialogItem}
                        style={{ position: "relative" }}
                      >
                        <ListItem>
                          <ListItemText
                            primary="Subject"
                            className={classes.linkItemText}
                          />
                          <div style={{ width: "250px" }}>
                            <Select
                              value={{
                                label: data[val.subjectIndex]?.first_name,
                              }}
                              onChange={(e) => {
                                setFieldValue(
                                  `${arrayName}[${index}].relationship[${key}].subjectIndex`,
                                  e.value,
                                  false,
                                );
                                setFieldValue(
                                  `${arrayName}[${index}].relationship[${key}].subjectId`,
                                  data[e.value].subject_id,
                                  false,
                                );
                              }}
                              options={relationshipOptions}
                            />
                          </div>
                        </ListItem>

                        <ListItem>
                          <ListItemText
                            primary="Relationship"
                            className={classes.linkItemText}
                          />
                          <Field
                            name={`${arrayName}[${index}].relationship[${key}].relationshipStatus`}
                            fullwidth={true}
                            style={{ width: "250px" }}
                            disableUnderline={true}
                            className={classes.input}
                            component={FMUSelect}
                            options={relationships}
                          />
                        </ListItem>
                        <RemoveCircleOutlined
                          style={{
                            position: "absolute",
                            right: -15,

                            color: tokens.color.brand.primaryAction,
                            cursor: "pointer",
                          }}
                          onClick={(e) => {
                            remove(key);
                          }}
                        />
                      </div>
                    );
                  })}
                  <Button
                    startIcon={<AddIcon style={{ fill: tokens.color.brand.primary }} />}
                    onClick={(e) => {
                      push({
                        relationshipStatus: "",
                        subjectIndex: -1,
                        subjectId: "",
                      });
                    }}
                    className={`${classes.btn} ${classes.dialogBtn}`}
                  >
                    Add new relationship
                  </Button>
                </>
              )}
            </FieldArray>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default RelationDialog;
